import { useEffect, useState } from 'react';

interface CountdownOptions {
  targetTimestamp?: number | null;
}

export function useCountdown({ targetTimestamp }: CountdownOptions) {
  const [isTimePassed, setIsTimePassed] = useState(!targetTimestamp);

  useEffect(() => {
    if (!targetTimestamp) return;

    function checkTime(ts: number) {
      const now = Date.now();
      const passed = now >= ts;

      setIsTimePassed(passed);

      if (passed) {
        clearInterval(intervalId);
      }
    }

    // 초기 체크
    checkTime(targetTimestamp);

    // 매 1초마다 체크
    const intervalId = setInterval(() => {
      checkTime(targetTimestamp);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [targetTimestamp]);

  return { isTimePassed };
}
